/**
 * Generates / formats a professional, unique, protected marketer ID based on the backend real ID.
 * E.g., MKT-7F3A9C12E4
 */
export const encryptMarketerId = (id) => {
  if (!id) return "";
  const strId = String(id).trim();
  if (/^MKT-[A-F0-9]{10}$/.test(strId)) return strId;

  try {
    let hash1 = 0;
    let hash2 = 0;
    const secret = "SelectEziProtectedMarketerSecretKey2026";
    const combined = strId + secret;

    for (let i = 0; i < combined.length; i++) {
      const char = combined.charCodeAt(i);
      hash1 = (hash1 << 5) - hash1 + char;
      hash1 |= 0;
    }
    for (let i = combined.length - 1; i >= 0; i--) {
      const char = combined.charCodeAt(i);
      hash2 = (hash2 << 7) - hash2 + char;
      hash2 |= 0;
    }

    const hex1 = Math.abs(hash1).toString(16).padStart(8, "0");
    const hex2 = Math.abs(hash2).toString(16).padStart(8, "0").substring(0, 2);
    return `MKT-${(hex1 + hex2).toUpperCase()}`;
  } catch (e) {
    return strId;
  }
};

export const decryptMarketerId = (encryptedStr) => {
  if (!encryptedStr || typeof encryptedStr !== "string") return encryptedStr;
  return encryptedStr.trim();
};
